module.exports = __webpack_public_path__ + "img/reception-pic.78bc2332.jpg";